import { Switch, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Image,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getDeactivatedListings,
  reactivateSku,
} from "../../../actions/listingsActions";
import { getUserFromLocalStorage } from "utilities/user";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import StorageIcon from "@material-ui/icons/Storage";
import CategoryIcon from "@material-ui/icons/Category";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import DateRangeIcon from "@material-ui/icons/DateRange";

const DeactivatedListings = () => {
  const user = getUserFromLocalStorage();
  const listings = useSelector((state) => state.listings);
  const { deactivatedListings, isLoading } = listings;
  const [reactivated, setReactivated] = useState(false);
  const [reactivatingId, setReactivatingId] = useState(null);
  const [selectedListing, setSelectedListing] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const dispatch = useDispatch();

  const handleOpenDetail = (listing) => {
    setSelectedListing(listing);
    setDetailModalOpen(true);
  };

  const handleCloseDetail = () => {
    setDetailModalOpen(false);
    setSelectedListing(null);
  };

  useEffect(() => {
    dispatch(getDeactivatedListings(user?.result?._id));
  }, [reactivated]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
        }}
      >
        <Spinner
          animation="border"
          variant="danger"
          style={{ width: "3rem", height: "3rem" }}
        />
        <p style={{ marginTop: "1rem", color: "#6c757d", fontWeight: 500 }}>
          Loading deactivated listings...
        </p>
      </div>
    );
  }

  const handleReactivation = async (listingId, userId) => {
    setReactivatingId(listingId);
    await dispatch(reactivateSku(listingId, userId));
    setReactivatingId(null);
    setReactivated(!reactivated);
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <Card
            style={{
              borderRadius: "16px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              border: "none",
              overflow: "hidden",
            }}
          >
            {/* Header with gradient */}
            <Card.Header
              style={{
                background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%)",
                borderBottom: "none",
                padding: "1.5rem 1.75rem",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <Card.Title
                    as="h4"
                    style={{
                      color: "#fff",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                      fontSize: "1.5rem",
                    }}
                  >
                    <BlockIcon
                      style={{
                        fontSize: 28,
                        marginRight: 10,
                        verticalAlign: "middle",
                      }}
                    />
                    Deactivated Listings
                  </Card.Title>
                  <p
                    style={{
                      color: "rgba(255, 255, 255, 0.9)",
                      margin: 0,
                      fontSize: "0.95rem",
                    }}
                  >
                    {deactivatedListings?.length || 0} products awaiting
                    reactivation
                  </p>
                </div>
                <div
                  style={{
                    background: "rgba(255, 255, 255, 0.2)",
                    borderRadius: "12px",
                    padding: "0.75rem 1.25rem",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: "1.75rem",
                    }}
                  >
                    {deactivatedListings?.length || 0}
                  </span>
                  <span
                    style={{
                      color: "rgba(255, 255, 255, 0.8)",
                      fontSize: "0.85rem",
                      display: "block",
                    }}
                  >
                    Total
                  </span>
                </div>
              </div>
            </Card.Header>

            <Card.Body style={{ padding: 0 }}>
              {deactivatedListings.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "4rem 2rem",
                    background:
                      "linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 1.5rem",
                      boxShadow: "0 8px 24px rgba(40, 167, 69, 0.2)",
                    }}
                  >
                    <CheckCircleOutlineIcon
                      style={{ fontSize: 50, color: "#28a745" }}
                    />
                  </div>
                  <h4
                    style={{
                      color: "#28a745",
                      fontWeight: 700,
                      marginBottom: "0.75rem",
                    }}
                  >
                    All Products Active!
                  </h4>
                  <p style={{ color: "#6c757d", maxWidth: "400px", margin: "0 auto" }}>
                    Great news! All your listings are currently active and
                    visible to customers.
                  </p>
                </div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <Table
                    hover
                    style={{
                      marginBottom: 0,
                      borderCollapse: "separate",
                      borderSpacing: 0,
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%)",
                        }}
                      >
                        <th
                          style={{
                            padding: "1rem 1.5rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Product
                        </th>
                        <th
                          style={{
                            padding: "1rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          <AttachMoneyIcon
                            style={{
                              fontSize: 16,
                              marginRight: 4,
                              verticalAlign: "middle",
                            }}
                          />
                          Price
                        </th>
                        <th
                          style={{
                            padding: "1rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          <CategoryIcon
                            style={{
                              fontSize: 16,
                              marginRight: 4,
                              verticalAlign: "middle",
                            }}
                          />
                          Category
                        </th>
                        <th
                          style={{
                            padding: "1rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          <StorageIcon
                            style={{
                              fontSize: 16,
                              marginRight: 4,
                              verticalAlign: "middle",
                            }}
                          />
                          Stock
                        </th>
                        <th
                          style={{
                            padding: "1rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Status
                        </th>
                        <th
                          style={{
                            padding: "1rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            textAlign: "center",
                          }}
                        >
                          View
                        </th>
                        <th
                          style={{
                            padding: "1rem 1.5rem",
                            fontWeight: 600,
                            color: "#495057",
                            borderBottom: "2px solid #dee2e6",
                            fontSize: "0.85rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            textAlign: "center",
                          }}
                        >
                          Reactivate
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {deactivatedListings.map((listing, index) => (
                        <tr
                          key={listing._id}
                          style={{
                            background:
                              index % 2 === 0 ? "#ffffff" : "#fafbfc",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#fff5f5";
                            e.currentTarget.style.transform = "scale(1.005)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background =
                              index % 2 === 0 ? "#ffffff" : "#fafbfc";
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <td
                            style={{
                              padding: "1rem 1.5rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <div
                                style={{
                                  position: "relative",
                                  marginRight: "15px",
                                }}
                              >
                                <Image
                                  src={listing.product_image}
                                  style={{
                                    width: 55,
                                    height: 55,
                                    borderRadius: "12px",
                                    objectFit: "cover",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    border: "2px solid #fff",
                                    filter: "grayscale(30%)",
                                    opacity: 0.85,
                                  }}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    top: -5,
                                    right: -5,
                                    width: 18,
                                    height: 18,
                                    borderRadius: "50%",
                                    background: "#dc3545",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <BlockIcon
                                    style={{ fontSize: 12, color: "#fff" }}
                                  />
                                </div>
                              </div>
                              <div>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    color: "#2d3436",
                                    fontSize: "0.95rem",
                                    marginBottom: "2px",
                                  }}
                                >
                                  {listing.title}
                                </div>
                                <small
                                  style={{
                                    color: "#6c757d",
                                    fontSize: "0.8rem",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    maxWidth: "200px",
                                  }}
                                >
                                  {listing.description}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "1rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                              fontWeight: 600,
                              color: "#2d3436",
                            }}
                          >
                            <span
                              style={{
                                background: "#e8f5e9",
                                color: "#2e7d32",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "0.9rem",
                              }}
                            >
                              UGX {listing.price?.toLocaleString()}
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "1rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <span
                              style={{
                                background: "#e3f2fd",
                                color: "#1565c0",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                                fontWeight: 500,
                              }}
                            >
                              {listing.category_name || listing.category}
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "1rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <span
                              style={{
                                background:
                                  listing.countInStock > 0
                                    ? "#fff3e0"
                                    : "#ffebee",
                                color:
                                  listing.countInStock > 0
                                    ? "#e65100"
                                    : "#c62828",
                                padding: "4px 12px",
                                borderRadius: "6px",
                                fontSize: "0.9rem",
                                fontWeight: 600,
                              }}
                            >
                              {listing.countInStock}
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "1rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <span
                              style={{
                                background:
                                  "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
                                color: "#c62828",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                fontSize: "0.8rem",
                                fontWeight: 600,
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                                boxShadow: "0 2px 4px rgba(198, 40, 40, 0.15)",
                              }}
                            >
                              <BlockIcon style={{ fontSize: 14 }} />
                              Deactivated
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "1rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                              textAlign: "center",
                            }}
                          >
                            <Tooltip title="View product details" arrow>
                              <IconButton
                                onClick={() => handleOpenDetail(listing)}
                                style={{
                                  background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                                  padding: "8px",
                                  boxShadow: "0 2px 6px rgba(25, 118, 210, 0.2)",
                                }}
                              >
                                <VisibilityIcon style={{ fontSize: 20, color: "#1565c0" }} />
                              </IconButton>
                            </Tooltip>
                          </td>
                          <td
                            style={{
                              padding: "1rem 1.5rem",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #eee",
                              textAlign: "center",
                            }}
                          >
                            <Tooltip
                              title="Click to reactivate this product"
                              arrow
                            >
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  background:
                                    "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                                  borderRadius: "25px",
                                  padding: "4px 8px",
                                  boxShadow:
                                    "0 2px 6px rgba(46, 125, 50, 0.15)",
                                }}
                              >
                                {reactivatingId === listing._id ? (
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    style={{ color: "#2e7d32" }}
                                  />
                                ) : (
                                  <Switch
                                    checked={false}
                                    onChange={() =>
                                      handleReactivation(
                                        listing._id,
                                        user?.result?._id
                                      )
                                    }
                                    color="primary"
                                    style={{ color: "#2e7d32" }}
                                  />
                                )}
                              </div>
                            </Tooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>

            {/* Footer with helpful info */}
            {deactivatedListings.length > 0 && (
              <Card.Footer
                style={{
                  background: "#f8f9fa",
                  borderTop: "1px solid #eee",
                  padding: "1rem 1.5rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                  }}
                >
                  <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>
                    💡 Toggle the switch to reactivate products and make them
                    visible to customers
                  </span>
                  <span
                    style={{
                      color: "#dc3545",
                      fontSize: "0.85rem",
                      fontWeight: 500,
                    }}
                  >
                    {deactivatedListings.length} product
                    {deactivatedListings.length !== 1 ? "s" : ""} need attention
                  </span>
                </div>
              </Card.Footer>
            )}
          </Card>
        </Col>
      </Row>

      {/* Detail View Modal */}
      <Dialog
        open={detailModalOpen}
        onClose={handleCloseDetail}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "16px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          style={{
            background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%)",
            color: "#fff",
            padding: "1.25rem 1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <InfoIcon />
            <span style={{ fontWeight: 600 }}>Product Details</span>
          </div>
          <IconButton
            onClick={handleCloseDetail}
            style={{ color: "#fff", padding: "4px" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: 0 }}>
          {selectedListing && (
            <div>
              {/* Product Image */}
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  background: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <Image
                  src={selectedListing.product_image}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
                    color: "#c62828",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <BlockIcon style={{ fontSize: 14 }} />
                  Deactivated
                </div>
              </div>

              {/* Product Info */}
              <div style={{ padding: "1.5rem" }}>
                <h4
                  style={{
                    margin: "0 0 0.5rem 0",
                    color: "#2d3436",
                    fontWeight: 700,
                  }}
                >
                  {selectedListing.title}
                </h4>
                <p
                  style={{
                    color: "#6c757d",
                    fontSize: "0.95rem",
                    marginBottom: "1.5rem",
                    lineHeight: 1.6,
                  }}
                >
                  {selectedListing.description}
                </p>

                {/* Details Grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1rem",
                  }}
                >
                  {/* Price */}
                  <div
                    style={{
                      background: "#e8f5e9",
                      padding: "1rem",
                      borderRadius: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        color: "#2e7d32",
                        fontSize: "0.8rem",
                        marginBottom: "4px",
                      }}
                    >
                      <AttachMoneyIcon style={{ fontSize: 16 }} />
                      Price
                    </div>
                    <div
                      style={{
                        color: "#1b5e20",
                        fontWeight: 700,
                        fontSize: "1.25rem",
                      }}
                    >
                      UGX {selectedListing.price?.toLocaleString()}
                    </div>
                  </div>

                  {/* Stock */}
                  <div
                    style={{
                      background: selectedListing.countInStock > 0 ? "#fff3e0" : "#ffebee",
                      padding: "1rem",
                      borderRadius: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        color: selectedListing.countInStock > 0 ? "#e65100" : "#c62828",
                        fontSize: "0.8rem",
                        marginBottom: "4px",
                      }}
                    >
                      <StorageIcon style={{ fontSize: 16 }} />
                      Stock
                    </div>
                    <div
                      style={{
                        color: selectedListing.countInStock > 0 ? "#bf360c" : "#b71c1c",
                        fontWeight: 700,
                        fontSize: "1.25rem",
                      }}
                    >
                      {selectedListing.countInStock} units
                    </div>
                  </div>

                  {/* Category */}
                  <div
                    style={{
                      background: "#e3f2fd",
                      padding: "1rem",
                      borderRadius: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        color: "#1565c0",
                        fontSize: "0.8rem",
                        marginBottom: "4px",
                      }}
                    >
                      <CategoryIcon style={{ fontSize: 16 }} />
                      Category
                    </div>
                    <div
                      style={{
                        color: "#0d47a1",
                        fontWeight: 600,
                        fontSize: "1rem",
                      }}
                    >
                      {selectedListing.category_name || selectedListing.category}
                    </div>
                  </div>

                  {/* Created Date */}
                  <div
                    style={{
                      background: "#f3e5f5",
                      padding: "1rem",
                      borderRadius: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        color: "#7b1fa2",
                        fontSize: "0.8rem",
                        marginBottom: "4px",
                      }}
                    >
                      <DateRangeIcon style={{ fontSize: 16 }} />
                      Created
                    </div>
                    <div
                      style={{
                        color: "#4a148c",
                        fontWeight: 600,
                        fontSize: "0.95rem",
                      }}
                    >
                      {selectedListing.createdAt
                        ? new Date(selectedListing.createdAt).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: "1rem 1.5rem",
            background: "#f8f9fa",
            borderTop: "1px solid #eee",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={handleCloseDetail}
            style={{
              color: "#6c757d",
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              if (selectedListing) {
                handleReactivation(selectedListing._id, user?.result?._id);
                handleCloseDetail();
              }
            }}
            style={{
              background: "linear-gradient(135deg, #4caf50 0%, #388e3c 100%)",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              padding: "8px 20px",
              borderRadius: "8px",
            }}
          >
            Reactivate Product
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default DeactivatedListings;
